<script setup>
import { ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useRouter } from 'vue-router';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const router = useRouter();
const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const appIdRef = ref();
const hookIdRef = ref();
const dialogRef = ref(null);
const uiFlags = getters['wgptIntegrations/getUIFlags'];

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('integrations/deleteHook', {
      appId: appIdRef.value,
      hookId: hookIdRef.value,
    });
    router.push({ name: 'settings_applications' });
  } catch (error) {
    const errorMessage =
      error?.message || t('WGPT_INTEGRATIONS.SALLA.EDITOR.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const open = ({ appId, hookId }) => {
  appIdRef.value = appId;
  hookIdRef.value = hookId;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_INTEGRATIONS.SALLA.EDITOR.SETTINGS.DELETE.CONFIRM.TITLE')"
    :description="
      t('WGPT_INTEGRATIONS.SALLA.EDITOR.SETTINGS.DELETE.CONFIRM.MESSAGE')
    "
    :confirm-button-label="
      t('WGPT_INTEGRATIONS.SALLA.EDITOR.SETTINGS.DELETE.CONFIRM.YES')
    "
    :cancel-button-label="
      t('WGPT_INTEGRATIONS.SALLA.EDITOR.SETTINGS.DELETE.CONFIRM.NO')
    "
    :is-loading="uiFlags.isDeletingSalla"
    :disable-confirm-button="uiFlags.isDeletingSalla"
    @confirm="handleDialogConfirm"
  />
</template>
